import type {StoreApi} from 'zustand/vanilla';

import type {Nullish} from 'shared/web';

import type {EagGridState, EagGridStore} from '../createEagGridStore';

type ResizeActions = Pick<
  EagGridStore,
  'setIsResizing' | 'setResizingColumn' | 'startResizing' | 'endResizing'
>;

/** Column resize actions. Bodies moved verbatim from createUiActions. */
export function createResizeActions(store: StoreApi<EagGridState>): ResizeActions {
  return {
    setIsResizing: (isResizing: boolean) => {
      if (store.getState().isResizing === isResizing) {
        return;
      }
      store.setState({isResizing});
    },

    setResizingColumn: (resizingColumn: string | Nullish) => {
      if (store.getState().resizingColumn === resizingColumn) {
        return;
      }
      store.setState({resizingColumn});
    },

    startResizing: (colKey: string) => {
      const state = store.getState();
      if (state.isResizing && state.resizingColumn === colKey) {
        return;
      }
      store.setState({isResizing: true, resizingColumn: colKey});
    },

    endResizing: () => {
      if (!store.getState().isResizing) {
        return;
      }
      store.setState({isResizing: false, resizingColumn: null});
    },
  };
}
